import React, { Component } from 'react';
import Fade from 'react-reveal';
import IconAlifFooter from '../icon/IconAlifFooter';
import IconGoogleplay from '../icon/IconGoogleplay';
import IconAppstore from '../icon/IconAppstore';
import IconVkontakte from '../icon/IconVkontakte';
import IconLinkedin from '../icon/IconLinkedin';
import IconFacebook from '../icon/IconFacebook';
import IconTelegram from '../icon/IconTelegram';
import IconInstagram from '../icon/IconInstagram';
import IconOdnok from '../icon/IconOdnok';
import IconTwitter from '../icon/IconTwitter';
import IconYoutube from '../icon/IconYoutube';
import FooterLegalInfo from '../navfooter/FooterLegalInfo';
import IconAlifMobi from '../alifmobiicon/IconAlifMobi';
import { connect } from 'react-redux';
import lang from '../../lang/lang.json';
import './footer.scss';

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onSelectCityHandler: '',
      isMobile: false,
    };
  }
  componentDidMount() {
    if (window.innerWidth <= 768) {
      this.setState({
        isMobile: true,
      });
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      onSelectCityHandler: props.cityHandler,
    });
  }

  render() {
    return (
      <div id="howToGet ">
        <div
          className={
            this.state.isMobile
              ? 'how-to-get container mobile-margin-top'
              : 'how-to-get getMargin '
          }
        >
          <Fade bottom>
            <div className="how-to-get-form footer-container">
              <div
                id="footerID"
                className={this.state.isMobile ? '' : 'container p-0 p-lg-3'}
              >
                <div className="dekstop-invisible">
                  <IconAlifMobi />
                </div>
                <div className="row ">
                  <div className="footer-order col-lg-4  col-md-6 col-sm-12">
                    <div>
                      <IconAlifFooter />
                    </div>
                    <span>
                      {lang.ALIF_ADDRESS_P_1[this.props.language]}
                      <br />
                      {lang.ALIF_ADDRESS_P_2[this.props.language]}
                      <br />
                    </span>
                    <span className="branch-alif">
                      <a href=" https://alif.tj/main/contacts/service-point?lang=ru">
                        {' '}
                        {lang.ALIF_ADDRESS_P_3[this.props.language]}
                      </a>
                    </span>
                  </div>
                  <div className="footer-order col-lg-4 d-flex  col-md-6 mb-md-3 mb-sm-5 col-sm-12">
                    <div className="service-div">
                      <span className="number-service">900</span>
                      <span className="number-service-text">
                        {lang.ALIF_PHONE_TEXT_1[this.props.language]}
                      </span>
                    </div>
                    <div className="service-div">
                      <span className="number-service">+992 48 888 1111</span>
                      <span className="number-service-text">
                        {lang.ALIF_PHONE_TEXT_2[this.props.language]}
                      </span>
                    </div>
                    <div className="service-div">
                      <span className="number-service">+992 44 600 1520</span>
                      <span className="number-service-text">
                        {lang.ALIF_PHONE_TEXT_3[this.props.language]}
                      </span>
                    </div>
                  </div>
                  <div className="footer-order col-lg-4 d-flex  col-md-6 mb-md-3 mb-sm-5 col-sm-12">
                    <div className="service-div appstorevisibility">
                      <span className="number-service">
                        {lang.ALIF_MOBILE_APP_INS[this.props.language]}
                      </span>
                      <span className="app-store-div">
                        <a
                          href="https://play.google.com/store/apps/details?id=tj.alif.mobi"
                          target="blank"
                        >
                          <IconGoogleplay />
                        </a>
                        <a
                          href="https://apps.apple.com/us/app/alif-mobi/id1331374853?l=ru&ls=1"
                          target="blank"
                        >
                          <IconAppstore />
                        </a>
                      </span>
                    </div>
                    <div className="service-div">
                      <span className="socil-media-title">
                        {lang.ALIF_SOC_MEDIA_TITLE[this.props.language]}
                      </span>
                      <span className="number-service-text social-icons">
                        <a target="blank" href="https://vk.com/alifbank">
                          <IconVkontakte />
                        </a>
                        <a
                          href="https://www.linkedin.com/company/alif-capital/mycompany/"
                          target="blank"
                        >
                          <IconLinkedin />
                        </a>
                        <a
                          target="blank"
                          href="https://www.facebook.com/alifbank.tj"
                        >
                          <IconFacebook />
                        </a>
                        <a target="blank" href="https://t.me/alifbank">
                          <IconTelegram />
                        </a>
                      </span>
                      <span className="social-icons">
                        <a
                          target="blank"
                          href="https://www.instagram.com/alifbank.tj/"
                        >
                          <IconInstagram />
                        </a>
                        <a target="blank" href="https://ok.ru/alifbank">
                          <IconOdnok />
                        </a>
                        <a target="blank" href="https://twitter.com/AlifBank">
                          <IconTwitter />
                        </a>
                        <a
                          target="blank"
                          href="https://www.youtube.com/channel/UCIxsoNNcNriGiNziF_bVSzQ"
                        >
                          <IconYoutube />
                        </a>
                      </span>
                    </div>
                  </div>
                  {/* <div className="footer-phone-invisible"> */}
                  <div className="container footer-invis"></div>
                  {/* </div> */}
                  <FooterLegalInfo />
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language.language,
  };
}

export default connect(mapStateToProps)(Footer);
